// extracted by mini-css-extract-plugin
export default {"wrapper":"Description_wrapper__-mVwc","description":"Description_description__8Y2lQ","darkMode":"Description_darkMode__aquyB","lightMode":"Description_lightMode__3aLXO"};